export default __webpack_public_path__ + "static/media/code-tag.4b0768c2.svg";